import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import Loader from "../../Layout/Loader/Loaders";
import axios from "axios";
import { Url } from "../../constants";
import { useNavigate } from "react-router-dom";

const TableRegistros = () => {

    const token = localStorage.getItem("token")
    const user_datos = JSON.parse(localStorage.getItem("user"))
    const Navigate = useNavigate()
    const [isCharging, setisCharging] = useState(false)
    
    const [registros, setregistros] = useState([])

    const getRegistrosDescargas = async () => {
        setisCharging(true)
        const dato = "Descarga Historica"

        await axios.get(Url + "HistorialArchivos", {
            headers:{
                Authorization: token
            }
        })
        .then(res => {
            setisCharging(false)
            setregistros(res.data[dato])
        })
        .catch(err => {
            setisCharging(false)
            console.log(err)
        })
    }

    useEffect(() => {
        if (token && !["null", "undefined"].includes(token)) {
            if ([3,5].includes(user_datos.roluser_id)) {
                Navigate("/archivos")
            } else if (user_datos.roluser_id === 4) {
                Navigate("/usuarios")
            } else {
                getRegistrosDescargas()
            }
        } else {
            Navigate("/login")
        }
    },[])

    const styleHead = {
        textAlign: "center",
        color: "white",
        backgroundColor: "#808b96"
        //fontWeight: "bold",
    }

    const styleRowBody = {
        textAlign: "center",
    }

    return (
        <div>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell sx={styleHead}>Usuario</TableCell>
                        <TableCell sx={styleHead}>Archivo</TableCell>
                        <TableCell sx={styleHead}>Fecha de Descarga</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {registros.map((registro, index) => (
                        <TableRow key={index} sx={{":hover":{backgroundColor:"#e5e7e9"}}}>
                            <TableCell sx={styleRowBody}>{registro.nombre_usuario || "Sin Nombre"}</TableCell>
                            <TableCell sx={styleRowBody}>{registro.nombre_archivo || "Sin Registro"}</TableCell>
                            <TableCell sx={styleRowBody}>{registro.updated_at}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            
            {isCharging && <Loader />}

        </div>
    );
}

export default TableRegistros;